import React from 'react';

import hibiscus from '../static/svg/1f33a.svg';

export default function Header() {
  return (
    <header className='m0a pb4 pt4 w90 w80-d'>
      <img src={hibiscus} className='hibiscus' alt='hibiscus' />
    </header>
  );
}
